// Content for the final webhook setup screen (guided onboarding + Settings verify).
// Two parts:
//  1. ADVANCED_WEBHOOK_DOC_URL — the universal "Optional Advanced Tracking" link (shown for every provider).
//  2. PLATFORM_SPECIFIC_GUIDES — curated per-provider guides, keyed by BACKEND PROCESSOR.
//     Only processors listed here render the extra "Platform-Specific Guides" card.

export const ADVANCED_WEBHOOK_DOC_URL = 'https://visiopt.com/help-center/webhook-advanced.html';

export interface PlatformGuideLink {
  label: string;
  url: string;
}

export interface PlatformGuides {
  // Rendered as: "Need help configuring additional webhooks for {label}?"
  label: string;
  links: PlatformGuideLink[];
}

export const PLATFORM_SPECIFIC_GUIDES: Record<string, PlatformGuides> = {
  clickfunnels: {
    label: 'ClickFunnels',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31112275086491-Connect-Cart-ClickFunnels-Using-Webhooks#h_01KYJ1MGSJFQDNMVVFVQ01NRVY',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31112275086491-Connect-Cart-ClickFunnels-Using-Webhooks#h_01KYJ36DD89N20JGZYWVZHKSYN',
      },
    ],
  },
  gohighlevel: {
    label: 'GoHighLevel',
    links: [
      {
        label: 'Product & Upsell Revenue Tracking',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/49463273918107-GoHighLevel-Product-Upsell-Revenue-Tracking',
      },
      {
        label: 'Surveys & Opt-ins',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/49463471544475-GHL-webhooks-for-Surveys-and-Opt-ins',
      },
    ],
  },
  chargebee: {
    label: 'Chargebee',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31109959003931-Connect-Payment-Processor-Chargebee-Using-Webhooks-OPTINS',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54416084388251-Connect-Payment-Processor-Chargebee-Using-Webhooks-Sale',
      },
    ],
  },
  woocommerce: {
    label: 'Woocommerce',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31114242363419-Connect-Cart-Woocommerce-Using-Webhooks-Opt-in',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54417526272411-Connect-Cart-Woocommerce-Using-Webhooks-Sale',
      },
    ],
  },
  shopify: {
    label: 'Shopify',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31113887520027-Connect-Cart-Shopify-Using-Webhooks-Opt-in',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54423031632411-Connect-Cart-Shopify-Using-Webhooks-Sale',
      },
    ],
  },
  katra: {
    label: 'Kartra',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54423634146971-Connect-Cart-Kartra-Using-Webhooks-Opt-in',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/31113087540635-Connect-Cart-Kartra-Using-Webhooks-Sale',
      },
    ],
  },
  stripe: {
    label: 'Stripe',
    links: [
      {
        label: 'Optin Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54429733620379-Connect-Payment-Processor-Stripe-Using-Webhooks-Opt-in',
      },
      {
        label: 'Sale Instructions',
        url: 'https://visiopt.zendesk.com/hc/en-us/articles/54429414733211-Connect-Payment-Processor-Stripe-Using-Webhooks-Sale',
      },
    ],
  },
};

export const platformGuidesFor = (processor: string): PlatformGuides | undefined =>
  PLATFORM_SPECIFIC_GUIDES[processor];
